import React from "react";
import ReviewsList from "../components/Reviews/ReviewsList";

function Reviews() {
  return (
    <div>
      <ReviewsList />
    </div>
  );
}

export default Reviews;
